const COLORS = {
  gold: '#D4A017',
  blue: '#1D9BF0',
  grey: '#8B98A5',
}

const LABELS = {
  gold: 'Verified (Gold)',
  blue: 'Verified (Blue)',
  grey: 'Verified (Grey)',
}

export default function VerifiedBadge({ badge, size = 14, className = '' }) {
  if (!badge || badge === 'none' || !COLORS[badge]) return null

  const color = COLORS[badge]

  return (
    <span
      role="img"
      aria-label={LABELS[badge]}
      title={LABELS[badge]}
      className={`inline-flex shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 22 22" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
        <path
          fill={color}
          d="M11 1.5l2.3 1.7 2.8-.4 1 2.6 2.6 1-.4 2.8 1.7 2.3-1.7 2.3.4 2.8-2.6 1-1 2.6-2.8-.4L11 20.5l-2.3-1.7-2.8.4-1-2.6-2.6-1 .4-2.8L1 11l1.7-2.3-.4-2.8 2.6-1 1-2.6 2.8.4L11 1.5z"
        />
        <path
          fill="white"
          d="M9.7 14.3L6.4 11l1.2-1.2 2.1 2.1 4.6-4.6 1.2 1.2z"
        />
      </svg>
    </span>
  )
}